/*********************************************************************
 * File Name: index.tsx
 * Description: TypeScript index file.
 * Author: Joseph Tolley
 * Date Created: 2024-08-05
 * Last Modified: 2024-08-05
 * Version: 1.0.0
 *********************************************************************/
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Amplify } from 'aws-amplify';
import awsconfig from './config/aws-exports';

Amplify.configure(awsconfig);

const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);



root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

//   const root = ReactDOM.render(document.getElementById("root") as HTMLElement);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );